import { render, staticRenderFns } from "./TaxGroupModal.vue?vue&type=template&id=2c19591e"
import script from "./TaxGroupModal.vue?vue&type=script&lang=js"
export * from "./TaxGroupModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports